// News, feature requests, and content management components
import { defineAsyncComponent } from 'vue'

export default {
  FeatureRequestFiltering: defineAsyncComponent(
    () => import('../feature_requests/filtering.vue')
  ),
  FeatureRequestForm: defineAsyncComponent(
    () => import('../feature_requests/form.vue')
  ),
  FeatureRequestTable: defineAsyncComponent(
    () => import('../feature_requests/table.vue')
  ),
  NewsItems: defineAsyncComponent(() => import('../news_items/news_items.vue')),
  NewsItemShow: defineAsyncComponent(() => import('../news_items/show.vue')),
  NewsItemsForm: defineAsyncComponent(() => import('../news_items/form.vue')),
  NewsItemsTable: defineAsyncComponent(
    () => import('../news_items/news_items_table.vue')
  )
}
